import React from 'react';
import theme from './TermsModal.module.scss';
import { Modal, ModalBody, Checkbox, LoadingIndicator, MarkdownDisplay } from '@ygtechnologies/bygr-frontend-component-library';
import { Trans } from '@lingui/react/macro';
import { Button } from '@/components/Buttons';
import ExternalLink from '@/components/navigation/ExternalLink';
import { useGetRubustechIoUrl, useIsBuyer } from '@/utils/hooks';
import { Terms } from '@/services/terms';

interface TProps {
    terms: Terms;
    profileName: string | null;
    checked: boolean;
    onCheckChange: (c: boolean) => void;
    isOpen: boolean;
    onAcceptClick: () => void;
    isSaving: boolean;
}

const TermsModal: React.FC<TProps> = ({ terms, checked, onCheckChange, isOpen, profileName, isSaving, onAcceptClick }) => {
    const termsLink = useGetRubustechIoUrl('terms-of-use');
    const privacyLink = useGetRubustechIoUrl('privacy-policy');

    const isBuyer = useIsBuyer();
    return (
        <Modal enableCloseButton={false} size="lg" isOpen={isOpen} toggle={() => {}} zIndexBase={20000}>
            <ModalBody className={theme.container}>
                <h5>
                    <Trans>Some formalities before you start using Rucoria...</Trans>
                </h5>
                <p>
                    <Trans>
                        In order to use Rucoria, you need to accept our terms of service, and review our privacy policies.
                    </Trans>
                </p>
                {terms && terms.sellerTermsText && (
                    <>
                        <span className={theme.infoLabel}>
                            <Trans>Specific terms and conditions for this project:</Trans>
                        </span>
                        <MarkdownDisplay className={theme.markdown} markdown={terms.sellerTermsText} />
                    </>
                )}
                <label className={theme.checkboxContainer}>
                    <Checkbox checked={checked} onChange={() => onCheckChange(!checked)} />{' '}
                    <Trans>
                        I reviewed and agree to the{' '}
                        <ExternalLink href={termsLink} target="_blank">
                            terms of conditions
                        </ExternalLink>{' '}
                        for using Rucoria
                    </Trans>
                </label>
                <div className={theme.acceptText}>
                    <Trans>
                        By clicking on "I accept" you are accepting the terms and condition for using Rucoria. In addition, you
                        are accepting the{' '}
                        <ExternalLink target="_blank" href={privacyLink}>
                            privacy policy of Rucoria AS
                        </ExternalLink>
                    </Trans>{' '}
                    {terms && terms.sellerPrivacyPolicyUrl && profileName && (
                        <>
                            <Trans>
                                and the{' '}
                                <ExternalLink href={terms.sellerPrivacyPolicyUrl} target="_blank">
                                    privacy policy of {terms.sellerPrivacyPolicyName || profileName}
                                </ExternalLink>
                            </Trans>
                        </>
                    )}
                </div>
                <div className={theme.buttons}>
                    {!terms && isBuyer ? (
                        <LoadingIndicator />
                    ) : (
                        <Button disabled={!checked} onClick={onAcceptClick} color="primary" loading={isSaving}>
                            <Trans>I accept</Trans>
                        </Button>
                    )}
                </div>
            </ModalBody>
        </Modal>
    );
};

export default TermsModal;
